import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import auth, { LoginDialog } from '@ifeng-fe/ui_pc_auth';
import { getScrollParent, smoothScroll } from '@src/public/utils';
import { addReplyUser, replyComment } from '../utils';
import { Store } from '../store';
import styles from './index.css';

const ReplyBtn = ({ subjectId, commentId }) => {
    const store = Store.useContainer();
    const { states, changeStates } = store;
    const { list, topIdList, replyList } = states;

    const wrapRef = useRef();

    const insertComment = insertItem => {
        const { rootId } = insertItem;
        const newList = [...list];

        if (rootId === '0') {
            // 一级评论
            const newTopIdList = [...topIdList, insertItem.id];

            newList.unshift(insertItem);

            changeStates({ list: newList, topIdList: newTopIdList });

            smoothScroll(getScrollParent(wrapRef.current), 0);
        } else {
            // 二级评论
            const newReplyList = [insertItem, ...replyList];

            addReplyUser(newReplyList);

            changeStates({ replyList: newReplyList });

            smoothScroll(getScrollParent(wrapRef.current), 0);
        }
    };

    const loginIdRef = useRef(auth.uuid());

    useEffect(() => {
        auth.event.on(auth.EVENTNAMES.login, () => {
            window.location.reload();
        });
    }, []);

    const handleReplyClick = () => {
        // 校验登录状态
        if (!auth.isLogin()) {
            auth.login(loginIdRef.current);

            return;
        }

        replyComment({ subjectId, rootId: commentId, pId: commentId, callback: insertComment });
    };

    return (
        <>
            <div className={styles.placeholder}>
                <div className={styles.content} />
            </div>
            <div className={styles.wrap} onClick={handleReplyClick} ref={wrapRef}>
                <div className={styles.content}>我来说两句~</div>
            </div>
            <LoginDialog id={loginIdRef.current} />
        </>
    );
};

ReplyBtn.propTypes = {
    subjectId: PropTypes.string,
    commentId: PropTypes.string,
};

export default errorBoundary(ReplyBtn);
